import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const callrail = defineConnector({
  identifier: "callrail",
  name: "CallRail",
  tagLine: "Call tracking and attribution",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.callrail\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "authorization",
        value: `token=${app.secret.apiKey}`,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Find your Callrail API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [CallRail authentication docs](https://apidocs.callrail.com/#authentication) and create or copy an API key from your CallRail account settings. Use a key from the account that owns the calls and forms data you want to access.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the API credentials from your Callrail account settings.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
          placeholder: "4f3c12efb9659a0b5c123b568745dbf9",
          helperText: "The API key for your Callrail account",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.callrail.com/v3/a.json",
  },
});
